// 문의 답변 상태 표시 문구.
export const inquiryStatusLabels = { pending: '답변 대기', answered: '답변 완료' };
